module.exports = __webpack_public_path__ + "img/Traktor_Feld.889ad7c7.jpg";